import React from 'react';
import { Calendar as CalendarIcon } from 'grommet-icons';
import { Box, Calendar, DropButton } from 'grommet';
import { toNYCTimeStamp, toLocalTimeStamp } from '../reporting-utils';

const DatePicker = ({
  dates,
  onSelect,
  range = true,
  date,
  dropAlign = { top: 'bottom', right: 'right' }
}) => {
  //since the datepicker renders dates in local timezone, we do a bit a trickery to convert dates from the NYC UTC timestamp to the user's local time
  // so that the user will see the same dates selected as someone who is in NYC timezone
  const datesToRender = range && [dates.map(d => toLocalTimeStamp(d))];
  return (
    <DropButton
      icon={
        <Box margin={{ vertical: 'small' }}>
          <CalendarIcon />
        </Box>
      }
      plain
      dropAlign={dropAlign}
      dropContent={
        <Box pad='medium' background='white'>
          {range ? (
            <Calendar
              size='small'
              range
              dates={datesToRender}
              onSelect={value => {
                let fromDate;
                let toDate;
                if (Array.isArray(value)) {
                  fromDate = new Date(value[0][0]);
                  toDate = new Date(value[0][1]);
                } else {
                  fromDate = new Date(value);
                  toDate = new Date(value);
                }

                fromDate.setHours(0, 0, 0, 0);
                toDate.setHours(23, 59, 59, 999);

                const fromNyc = toNYCTimeStamp(fromDate);
                const toNyc = toNYCTimeStamp(toDate);

                onSelect([fromNyc, toNyc]);
              }}
            />
          ) : (
            <Calendar size='small' date={date} onSelect={onSelect} />
          )}
        </Box>
      }
    />
  );
};

DatePicker.displayName = 'DatePicker';

export default DatePicker;
